import { Box } from '@mui/material';
import { useTreeViewApiRef } from '@mui/x-tree-view/hooks';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAllowedActions } from '../../app/library/librarySlice';
import { RootState } from '../../app/store';
import DeleteConfirmationModal from './components/DynamicTree/components/DeleteConfirmationModal';
import { DynamicTree } from './components/DynamicTree/DynamicTree';
import { Header } from './components/Header';
import MovePickerModal from './components/MovePicker/MovePickerModal';
import NoPermissionText from './components/NoPermissionText';
import UploaderModal from './components/Uploader/UploaderModal';
import { ViewPanel } from './components/ViewPanel/ViewPanel';
import { ContentContainer } from './StyledComponents';

const Library = () => {
  const apiRef = useTreeViewApiRef();
  const dispatch = useDispatch();
  const { actions } = useSelector((state: RootState) => state.user);
  const [isListViewEnabled, setIsListViewEnabled] = useState<boolean>(true);

  useEffect(() => {
    const userAllowedActions = actions?.filter((action) =>
      action?.scope?.includes('Directory'),
    );

    setIsListViewEnabled(
      !!userAllowedActions.find(({ action }) =>
        action?.includes('list-directories'),
      ),
    );

    dispatch(setAllowedActions(userAllowedActions));
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        p: 3,
      }}
    >
      {isListViewEnabled ? (
        <React.Fragment>
          <Header />
          <ContentContainer>
            <DynamicTree treeRef={apiRef} />
            <ViewPanel treeRef={apiRef} />
          </ContentContainer>
        </React.Fragment>
      ) : (
        <NoPermissionText text={'Library is Unavailable.'} />
      )}
      <UploaderModal />
      <DeleteConfirmationModal />
      <MovePickerModal />
    </Box>
  );
};

export default Library;
